/** ODP v2 spacing tokens — 4px base grid */

export const spacingScale = {
  xs: 4,
  sm: 8,
  md: 12,
  base: 16,
  lg: 20,
  xl: 24,
  '2xl': 32,
  '3xl': 40,
  '4xl': 48,
  '5xl': 64,
} as const;

/** Spacing unit multiplier (n * 4px), matching MUI theme.spacing convention */
export const spacing = (n: number) => n * 4;

/** Alias for spacing() */
export const sp = spacing;
